import React, { Component } from 'react';

import {
	ListItem,
	ListText,
	NavigateNextIcon,
	CenterWrapper,
	List,
} from './styles';
import { UPLOAD_STATUS } from '../../constants';

const STEPS = [
	{
		name: 'Upload Data',
		index: 0,
	},
	{
		name: 'Configure harmonisation',
		index: 1,
	},
	{
		name: 'Configure classification',
		index: 2,
	},
	{
		name: 'Spend cube generation',
		index: 3,
	},
];

export default class UploadStepsHeader extends Component {
	render() {
		const {
			activeStepIndex,
			onStepClick,
			showHarmonisation,
			status,
			isDirect,
		} = this.props;
		const lastStepIndex = STEPS.length - 1;
		const isNotOnLastStep = activeStepIndex < lastStepIndex;
		const optionsByDirection = isDirect
			? STEPS.filter(({ index }) => index !== 2)
			: STEPS;
		const stepsOptions = showHarmonisation
			? optionsByDirection
			: optionsByDirection.filter((item, i) => i !== 1);
		const isFailed =
			status.state === UPLOAD_STATUS.FAILED ||
			(status.errors && status.errors.length > 0);

		return (
			<CenterWrapper>
				<List>
					{stepsOptions.map(step => (
						<ListItem
							key={step.name + step.index}
							passed={step.index < activeStepIndex}
							active={step.index === activeStepIndex}
							isFailed={isFailed && step.index === 0}
							onClick={
								step.index < activeStepIndex && isNotOnLastStep
									? () => onStepClick(step.index)
									: null
							}
						>
							<NavigateNextIcon />
							<ListText>{step.name}</ListText>
						</ListItem>
					))}
				</List>
			</CenterWrapper>
		);
	}
}
